// Shared helpers for login / sign-up

// Saves the logged-in user the same way Login.jsx always did
// (sessionStorage + localStorage with a 1-day expiry).
export function saveUserSession(data) {
  const userData = {
    token: data.token,
    id: data.user._id || data.user.id,
    name: data.user.name,
    email: data.user.email,
    mobile: data.user.mobile,
    role: data.user.role,
    birthTime: data.user.birthTime,
    birthPlace: data.user.birthPlace,
    dob: data.user.dob,
    kundaliUrl: data.user.kundaliUrl,
  };

  sessionStorage.setItem("user", JSON.stringify(userData));

  const oneDay = 24 * 60 * 60 * 1000;
  localStorage.setItem(
    "user",
    JSON.stringify({ ...userData, expiry: Date.now() + oneDay })
  );

  return userData;
}

// Reads ?next=/some/path from the URL. Only allows paths inside this site.
export function getSafeNext(search) {
  const next = new URLSearchParams(search || "").get("next");
  if (next && next.startsWith("/") && !next.startsWith("//")) return next;
  return null;
}